import { assert } from '@/shared/lib/assert.ts'

import { useSets } from './useSets.ts'

export const useActiveSet = () => {
	const sets = useSets()

	if (sets.data === undefined) return null
	if (sets.data.sets.length === 0) return null

	const selectedSet = sets.data.sets.find(set => set.isSelected)

	assert(selectedSet !== undefined)

	return selectedSet
}
